import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { jsx as _jsx } from "react/jsx-runtime";
export const ACContentCardThumbnailIcon = props => {
  const {
    illustration,
    icon,
    backgroundColor,
    pictogram
  } = props;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'fill-accent-neutral-subtle-alt',
    blockSize: "100%",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      blockSize: "70%",
      inlineSize: "70%",
      justifyContent: "center",
      children: icon || (pictogram ? /*#__PURE__*/_jsx(Pictogram, {
        inlineSize: "100%",
        name: pictogram || ''
      }) : /*#__PURE__*/_jsx(Illustration, {
        name: illustration || ''
      }))
    })
  });
};